import { render } from "./UploadTemplatePopup.vue?vue&type=template&id=23942029&scoped=true&ts=true"
import script from "./UploadTemplatePopup.vue?vue&type=script&lang=ts"
export * from "./UploadTemplatePopup.vue?vue&type=script&lang=ts"

import "./UploadTemplatePopup.vue?vue&type=style&index=0&id=23942029&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23942029"]])

export default __exports__